import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types/media';
import { MEDIA_TYPE_LABEL } from '@/types/media';

export default function FeaturedPanel({ items }: { items: MediaItem[] }) {
  return (
    <ol className="flex flex-col gap-1">
      {items.map((item, index) => (
        <li key={item.id}>
          <Link
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors"
          >
            <span
              className={`w-6 text-center font-heading font-black text-lg shrink-0 ${
                index < 3 ? 'text-primary-500' : 'text-foreground-300'
              }`}
            >
              {index + 1}
            </span>
            <img src={item.poster} alt={item.title} className="w-11 h-16 rounded object-cover object-top bg-background-200" />
            <span className="flex flex-col gap-1 min-w-0">
              <span className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {item.title}
              </span>
              <span className="text-xs text-foreground-500 truncate">
                {MEDIA_TYPE_LABEL[item.type]} · {item.genres.slice(0, 2).join('·')}
              </span>
              <span className="inline-flex items-center gap-1 text-xs font-bold text-primary-500">
                <i className="ri-star-fill"></i>
                {item.rating.toFixed(1)}
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}